//@flow

const ApiName = {
    GetToken: 'GetToken',
    GetTokenOAuth: 'GetTokenOAuth',
    TaxSoftware: 'TaxSoftware',
    BinderTypes: 'BinderTypes',
    ServiceTypes: 'ServiceTypes',
    BinderTemplates: 'BinderTemplates',
    OfficeLocations: 'OfficeLocations',
    BinderStatusList: 'BinderStatusList',
    CreateBinder: 'CreateBinder',
    UploadBinder: 'UploadBinderDocuments',
    BinderSubmit: 'BinderSubmissionComplete',
    GetStatus: 'getstatus',
    GetDocuments: 'GetDocuments',
    DownloadDocuments: 'DownloadDocument',
    ChangeBinderStatus: 'ChangeBinderStatus',
    GetStateandLocation: 'GetStatesandLocalities',
    DownloadBinder: 'DownloadBinderPBFX',
    GetBinderDetails: 'GetBinderDetails',
    BinderDetails: 'BinderDetails',
    UnClearNotes: 'UnclearedNotes',
    UnReviewedTrs: 'UnreviewedTRStamps',
    GetUnreviewedStickyNotes: 'GetUnreviewedStickyNotes',
    UnReviewedWorkPaper1: 'UnreviewedWorkpapersByL1',
    UnReviewedWorkPaper2: 'UnreviewedWorkpapersByL2',
    UnReviewedWorkPaper3: 'UnreviewedWorkpapersByL3',
    UnReviewedWorkPaper4: 'UnreviewedWorkpapersByL4',
    RequestedDocsPendingReview: 'RequestedDocsPendingReview',
    RequestedDocsPendingSignature: 'RequestedDocsPendingSignature',
    RequestedDocsPendingUpload: 'RequestedDocsPendingUpload',
    GetBinderInfo: 'GetBinderInfo',
    BinderAuditLog: 'GetBinderAuditLog',
    OCR: 'OCR',
    PushEngagementStatus: 'PushEngagementStatus',
    PushDocumentType: 'PushDocumentType',
    DocumentsUploaded: 'DocumentsUploaded',
    DRL: 'DRL',
    NewFileAvailable: 'NewFileAvailable',
    MIReport: 'MIReport',
    GetDRLOutput: 'GetDRLOutput',
    UpdateProjectID: 'UpdateProjectID',
    GetBinderStatuswithStates: 'GetBinderStatuswithStates',
    DRLCategories: 'DRLCategories',
    AcceptedFiles: 'AcceptedFiles',
    DRLOutputNotification: 'DRLOutputNotification',
    UpdateOwnerMember: 'UpdateOwnerMember',
    AccountUsageHistory: 'AccountUsageHistory',
    PrintBinder: 'PrintBinder',
    CreateClient: 'CreateClient',
    GetClientDetails: 'GetClientDetails',
    CreateDrl:'CreateDrl',
    SendDrl:'SendDrl',
    ClientSubscribe: 'ClientSubscribe',
    ClientUnsubscribe: 'ClientUnsubscribe',
    GetDRLPDFDetails: 'GetDRLPDFDetails',
    TaxcaddyDownloadDocument: 'TaxcaddyDownloadDocument',
    GetDRLStatus: 'GetDRLStatus',
    TaxcaddyDisconnectDevices: 'TaxcaddyDisconnectDevices'
    
};

export default ApiName;
